export const TASTE_OF_GOLD_TAKEOVER_ID = 'taste-of-gold'
export const TASTE_OF_GOLD_CAMPAIGN_BENEFIT = 'airport_transfer' as const
export const TASTE_OF_GOLD_TRANSFER_IMAGE_ID = 'loyalty-tog-6e16c1e86f5f'
export const TASTE_OF_GOLD_MIN_PRICE = 1500
